import { singletonAtom } from '@/context/atoms/helper/singletonAtom';
import { type AuthMechanism } from '@ekkogmbh/apisdk';
import { jwtAuthMechanismAtom } from '@/context/atoms/JWTAuthMechanism';
import { webEamAuthMechanismAtom } from '@/context/atoms/WebEamAuthMechanism';
import { AuthMechanismEnum } from '@/helper/AppTypes';
import { publicConfigAtom } from '@/context/atoms/publicConfig';

export const authMechanismAtom = singletonAtom<Promise<AuthMechanism>>(async (get) => {
  const publicConfig = await get(publicConfigAtom);

  if (publicConfig.env.AUTH_MECHANISM === AuthMechanismEnum.webeam) {
    return await get(webEamAuthMechanismAtom);
  }

  return await get(jwtAuthMechanismAtom);
});
